export const snackbar = {
  namespaced: true,
  state: {
    queue: []
  },
  getters: {
    queue(state) {
      return state.queue;
    }
  },
  mutations: {
    push(state, { text, icon, accept, deny }) {
      state.queue.push({
        text,
        icon,
        accept: async () => {
          state.queue.shift();
          await accept();
        },
        deny: async () => {
          state.queue.shift();
          await deny();
        }
      });
    }
  },
  actions: {
    shift({ state }) {
      return state.queue.shift();
    }
  }
};
